<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="service-fee-statement-select-dialog ah-detail-dialog"
        append-to-body
        top="5vh"
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">加選勞報單</template>
        <div style="padding: 10px 30px 0px 30px;">
            <el-form label-position="top" class="form">
                <el-form-item label="領款人">
                    <el-input v-model="queryParams.payee" style="width: 230px" size="small" placeholder="請輸入領款人" @keyup.enter.native="updateData(true)" disabled>
                        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="updateData(true)" />
                    </el-input>
                </el-form-item>
                <el-form-item label="預計付款期間">
                    <el-date-picker
                        :default-time="['00:00:00', '23:59:59']"
                        v-model="payDateRange"
                        value-format="timestamp"
                        type="daterange"
                        range-separator="~"
                        start-placeholder="開始日期"
                        end-placeholder="結束日期"
                        style="width: 100%"
                        size="small"
                        :clearable="true"
                        @change="updateData"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="摘要關鍵字">
                    <el-input v-model="queryParams.nam" style="width: 230px" size="small" placeholder="請輸入摘要" @keyup.enter.native="updateData(true)">
                        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="updateData(true)" />
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <div style="padding: 0px 30px 10px 30px;">
            <el-alert type="warning" :closable="false">合併轉送條件：領款人、專案、所得類別、業別代號、幣別、付款方式，以上均需相同</el-alert>
            <el-table
                v-loading="isLoading"
                :data="datas"
                ref="table"
                empty-text="查無待請款勞務單"
                style="width: 100%"
                :row-class-name="rowStyle"
                @selection-change="onSelectionChange"
            >
                <el-table-column key="selection" type="selection" width="50" :selectable="isSelectable"></el-table-column>
                <!-- <el-table-column prop="typ" label="填單方式" width="80">
                    <template slot-scope="scope">
                        <div>{{ scope.row.typ === 1 ? "公司填寫" : "領款人填寫" }}</div>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="crt_nam" label="建立人" width="80" /> -->
                <el-table-column prop="status" label="狀態" width="80">
                    <template slot-scope="scope">
                        <StatusLabel :statusNum="scope.row.status" />
                    </template>
                </el-table-column>
                <el-table-column prop="nam" label="勞報單摘要" min-width="200" />
                <el-table-column prop="projectNam" label="專案" show-overflow-tooltip width="130">
                    <template slot-scope="scope">
                        {{ scope.row.projectNam || "--" }}
                    </template>
                </el-table-column>
                <el-table-column prop="payee" label="領款人" width="110" />
                <el-table-column prop="incomeType" label="所得類別" width="80">
                    <template slot-scope="scope">
                        <span>{{ getIncomeType(scope.row.incomeType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="incomeType" label="業別代號" width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ getServiceType(scope.row.serviceType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="plannedPayDat" label="預計付款日" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.plannedPayDat | dateFormater("YYYY-MM-dd") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="plannedPayWay" label="支領方式" width="100" align="right">
                    <template slot-scope="scope">
                        <span>{{ getServiceFeePlannedPayWayTxt(scope.row.plannedPayWay) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amt" label="應付金額" width="100" align="right">
                    <template slot-scope="scope">
                        <Money :v="scope.row.amt" />
                    </template>
                </el-table-column>
                <el-table-column prop="cny" label="幣別" width="58" />
            </el-table>
        </div>
        <div style="padding: 10px; text-align: center;">
            <div class="pagination">
                <el-pagination
                    layout="prev, pager, next"
                    :page-size.sync="queryParams.PageSize"
                    :total.sync="totalDataCount"
                    :current-page.sync="queryParams.PageNum"
                    @current-change="updateData(false)"
                >
                </el-pagination>
            </div>
            <div style="margin-top: 20px">
                <el-tooltip v-if="selectedItems.length" class="item" effect="dark" content="未符合轉送條件" placement="top" :manual="isTransformable">
                    <el-button type="primary" :disabled="!isTransformable" @click="onSubmit">加入</el-button>
                </el-tooltip>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import {
    serviceFeeStatementType, serviceTypeList, serviceType9AList, serviceType9BList, serviceFeePlannedPayWay,
} from '@/assets/commonData/options';
import StatusLabel from '@/components/dashboard/ServiceFeeStatement/StatusLabel.vue';

export default {
    name: 'ServiceFeeStatementDetailDialog',
    components: { StatusLabel },
    props: {
        visible: Boolean,
        sno: Number,
        selectedList: {
            type: Array,
            default: () => [],
        },
        payment: {
            type: Object,
            default: () => {},
        },
        payeeName: {
            type: String,
            default: null,
        },
    },
    computed: {
        isTransformable() {
            const HAS_PAYED = _.filter(this.selectedItems, (o) => o.status !== 1 && o.status !== 3).length > 0;

            if (this.payment) {
                const IS_VDR_SAME = !_.find(this.selectedItems, (o) => o.personalOutsourcingSno !== this.payment.vdR_SNO);
                const IS_PJ_SAME = this.payment.projectSNO
                    ? _.filter(this.selectedItems, (o) => o.projectSno !== this.payment.projectSNO).length === 0
                    : _.filter(this.selectedItems, (o) => o.projectSno !== null).length === 0;
                const IS_USER_PAY_WAY_SAME = this.payment.useR_PAY_WAY === 2 ? !_.find(this.selectedItems, (o) => o.plannedPayWay !== 2) : !_.find(this.selectedItems, (o) => o.plannedPayWay !== 1);
                const IS_PAY_WAY_SAME = this.payment.paY_WAY === 2 ? !_.find(this.selectedItems, (o) => o.plannedPayWay !== 2) : !_.find(this.selectedItems, (o) => o.plannedPayWay !== 1);

                const CHECK_USER_PAY_WAY = this.payment.sigN_STS === 1 || this.payment.sigN_STS === 4 || this.payment.sigN_STS === 5 ? IS_USER_PAY_WAY_SAME : true;
                const CHECK_PAY_WAY = this.payment.sigN_STS === 2 || this.payment.sigN_STS === 3 ? IS_PAY_WAY_SAME : true;

                return IS_VDR_SAME && IS_PJ_SAME && CHECK_USER_PAY_WAY && CHECK_PAY_WAY;
            }

            const LIST = [...this.selectedList, ...this.selectedItems];

            const IS_PAYEE_SAME = _.uniqBy(LIST, 'payee').length === 1;
            const IS_PROJECT_SAME = _.uniqBy(LIST, 'projectNam').length === 1;
            const IS_CNY_SAME = _.uniqBy(LIST, 'cny').length === 1;
            // const IS_PLANNED_PAY_DAT_SAME = _.uniqBy(LIST, 'plannedPayDat').length === 1;
            const IS_INCOME_TYPE_SAME = _.uniqBy(LIST, 'incomeType').length === 1;
            const IS_SERVICE_TYPE_SAME = _.uniqBy(LIST, 'serviceType').length === 1;

            return IS_PAYEE_SAME && IS_PROJECT_SAME && IS_CNY_SAME && IS_INCOME_TYPE_SAME && IS_SERVICE_TYPE_SAME && !HAS_PAYED;
        },
    },
    data() {
        return {
            isLoading: false,
            payDateRange: [],

            queryParams: {
                payee: null,
                nam: null,
                status: 3,
                PageSize: 10,
                PageNum: 1,
            },
            totalDataCount: 0,
            datas: [],

            selectedItems: [],
        };
    },
    methods: {
        async onOpen() {
            if (this.payeeName) {
                this.queryParams.payee = this.payeeName;
            }
            this.updateData();
        },
        async updateData() {
            this.queryParams.PageNum = 1;

            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'ServiceOrder/QueryServiceFeeStatement',
                    method: 'GET',
                    params: {
                        PayDatStart: this.payDateRange[0],
                        PayDatEnd: this.payDateRange[1],
                        ...this.queryParams,
                    },
                });
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此勞報單？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: 'ServiceOrder/DeleteServiceFeeStatement',
                    method: 'DELETE',
                    data: { sno: this.sno },
                });
                this.$emit('close', true);
            } catch (e) {
                console.log(e);
            }
        },
        onEdit() {
            this.$router.push({ name: 'edit-service-fee-statement', params: { sno: this.sno } });
        },

        // 關閉視窗
        onBeforeClose() {
            this.$emit('close', true);
        },

        onSelectionChange(selections) {
            this.selectedItems = selections;
        },

        getServiceFeeStatementType(value) {
            return _.find(serviceFeeStatementType, ['key', value])?.value;
        },
        getIncomeType(value) {
            return _.find(serviceTypeList, ['value', value])?.type;
        },
        getServiceType(value) {
            return _.find([...serviceType9AList, ...serviceType9BList], ['key', value])?.label;
        },
        getServiceFeePlannedPayWayTxt(value) {
            return _.find(serviceFeePlannedPayWay, ['key', value])?.label;
        },
        onSubmit() {
            this.$emit('submit', this.selectedItems);
        },
        isSelectable({ sno }) {
            // 已在選取列表中，不可選
            if (_.find(this.selectedList, ['sno', sno])) {
                return false;
            }

            // 未符合轉送請款單限制，已第一筆已有的資料來判斷
            if (this.selectedList.length > 0) {
                const sampleServiceFee = this.selectedList[0];
                const rowServiceFee = this.datas.find((x) => x.sno === sno);
                // 需同收款人
                if (sampleServiceFee.payee !== rowServiceFee.payee) {
                    return false;
                }
                // 需同專案
                if (sampleServiceFee.projectSno !== rowServiceFee.projectSno) {
                    return false;
                }
                // 需同所得類別
                if (sampleServiceFee.incomeType !== rowServiceFee.incomeType) {
                    return false;
                }
                // 需同業別代碼
                if (sampleServiceFee.serviceType !== rowServiceFee.serviceType) {
                    return false;
                }
                // 需同幣別
                if (sampleServiceFee.cny !== rowServiceFee.cny) {
                    return false;
                }
                // 需同預計支領方式
                if (sampleServiceFee.plannedPayWay !== rowServiceFee.plannedPayWay) {
                    return false;
                }
            }

            return true;
        },
        rowStyle({ row }) {
            return this.isSelectable({ sno: row.sno }) ? '' : 'not-qualified-row';
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";
.service-fee-statement-select-dialog .form {
    display: flex;
    > :not(:last-child) {
        margin-right: 15px;
    }
}

.service-fee-statement-select-dialog.ah-detail-dialog {
    @media print {
        position: relative;
    }

    .el-dialog {
        margin-top: 6vh;
        background-color: #fff;
        max-width: 1200px;
    }

    .cny {
        font-size: 9pt;
        opacity: 0.7;
        margin: 0 0 0 10px;
    }

    .dialog-section {
        // border-top: 1px solid #eee;
        padding: 20px 30px;
        background-color: #fff;
        margin: 10px 10px;
        border-radius: 0px;
        border-left: 4px solid transparent;

        @media (max-width: 720px) {
            padding: 20px 13px;
        }

        > .dialog-section-title {
            display: table;
            width: 100%;
            margin: 0px 0 20px 0;
            font-size: 12pt;
            font-weight: 600;
            color: $main-color;
        }
    }
    .not-qualified-row {
        color: #ccc;

        .status-label {
            opacity: 0.3;
        }
    }
}
</style>

<style lang="scss" scoped></style>
